export const AddressAnswerStyles = () => `
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 22px;
`;

export const AddressContainerStyles = () => `
  margin-top: 16;
`;

export const AddressOptionsContainerStyles = (props: any) => `
  max-height: ${props.height};
  height: auto;
  overflow: hidden;
  margin-top: 16;
`;
